var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9531 8.53125H57.9844V47.2031H1.5V8.53125H8.53125",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7109 57.9844V47.2031",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7734 47.2031V57.9844",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6797 57.9844H43.8047",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9531 40.1719H8.53125V1.5H50.9531V40.1719Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2578 22.5938L36.7734 33.1406L43.8047 26.1094L33.2578 22.5938Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 8.53125C17.4375 9.50203 16.6505 10.2891 15.6797 10.2891C14.7089 10.2891 13.9219 9.50203 13.9219 8.53125C13.9219 7.56047 14.7089 6.77344 15.6797 6.77344C16.6505 6.77344 17.4375 7.56047 17.4375 8.53125Z",
    fill: "#43768A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4688 8.53125C24.4688 9.50203 23.6817 10.2891 22.7109 10.2891C21.7402 10.2891 20.9531 9.50203 20.9531 8.53125C20.9531 7.56047 21.7402 6.77344 22.7109 6.77344C23.6817 6.77344 24.4688 7.56047 24.4688 8.53125Z",
    fill: "#43768A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 8.53125C31.5 9.50203 30.713 10.2891 29.7422 10.2891C28.7714 10.2891 27.9844 9.50203 27.9844 8.53125C27.9844 7.56047 28.7714 6.77344 29.7422 6.77344C30.713 6.77344 31.5 7.56047 31.5 8.53125Z",
    fill: "#43768A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53125 15.5625H50.9531",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8047 33.1406L40.2891 29.625",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6797 22.5938H26.2266",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6797 29.625H26.2266",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.968e12ec8e0538ded8ad2a2cc63d7c38.svg";
export { ForwardRef as ReactComponent };